import { Box } from "@chakra-ui/react";
import React from "react";

import useIsMounted from "lib/hooks/useIsMounted";
import DataListDisplay from "ui/shared/DataListDisplay";

import AddressAuthorizationsList from "./authorizations/AddressAuthorizationsList";
import AddressAuthorizationsTable from "./authorizations/AddressAuthorizationsTable";
import useAddressSignedAuthorizationsQuery from "./useAddressSignedAuthorizationsQuery";

type Props = {
  shouldRender?: boolean;
  isQueryEnabled?: boolean;
  queryOverride?: ReturnType<
    typeof useAddressSignedAuthorizationsQuery
  >["query"];
};

const AddressAuthorizations = ({
  shouldRender = true,
  isQueryEnabled = true,
  queryOverride,
}: Props) => {
  const isMounted = useIsMounted();
  const fallback = useAddressSignedAuthorizationsQuery({
    enabled: isQueryEnabled,
  });
  const query = queryOverride ?? fallback.query;
  const { data, isPlaceholderData, isError } = query;

  if (!isMounted || !shouldRender) {
    return null;
  }

  const content = data?.length ? (
    <>
      <Box hideBelow="lg">
        <AddressAuthorizationsTable data={data} isLoading={isPlaceholderData} />
      </Box>
      <Box hideFrom="lg">
        <AddressAuthorizationsList data={data} isLoading={isPlaceholderData} />
      </Box>
    </>
  ) : null;

  return (
    <DataListDisplay
      isError={isError}
      itemsNum={data?.length}
      emptyText="There are no authorizations for this address."
    >
      {content}
    </DataListDisplay>
  );
};

export default AddressAuthorizations;
